export const INCIDENTS = {
  titleInput: 'incident-title-input',
  descriptionInput: 'incident-description-input',
  categorySelect: 'incident-category-select',
  categoryOption: (key) => `incident-category-option-${key}`,
  locationInput: 'incident-location-input',
  dateInput: 'incident-date-input',
  evidenceUploadInput: 'incident-evidence-upload-input',
  contactPhoneInput: 'incident-contact-phone-input',
  contactMethodSelect: 'incident-contact-method-select',
  followUpConsentCheckbox: 'incident-follow-up-consent-checkbox',
  submitButton: 'incident-submit-button',
  myIncidentsList: 'incident-my-list',
  incidentRow: (id) => `incident-row-${id}`,
};
